import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { config } from 'process';

@Component({
  selector: 'child-cell',
  template: `
    <div class="flex align-items-center list-user-action">
        <ng-container  *ngIf="action.edit">
          <a  class="" href="javascript:void(0)" title="Edit" (click)="invokeParentEditMethod()">
              <i class="bx bx-edit text-success me-1 font-size-16"></i>
        </a>
        </ng-container>
        <ng-container  *ngIf="action.updateDue">
          <a  class="" href="javascript:void(0)" (click)="invokeParentUpdateAmountMethod()">
              <i *ngIf="noPendingAmount" title="Update due amount" class="fas fa-file-invoice-dollar text-success me-1 font-size-16"></i>
              <i *ngIf="!noPendingAmount" title="view due amount" class="fas fa-file-invoice-dollar text-warning me-1 font-size-16"></i>
        </a>
        </ng-container>
        <ng-container  *ngIf="action.view">
          <a  class="" href="javascript:void(0)" title="View" (click)="invokeParentViewMethod()">
              <i class="mdi mdi-file-eye text-secondary me-1 font-size-16"></i>
        </a>
        </ng-container>
        <div *ngIf="action.print" ngbDropdown container="body" class="d-inline-block text-sm-end flex-grow-1 flex-end mt-1">
            <a class="" href="javascript:void(0)" title="Print" ngbDropdownToggle>
                <i class="bx bx-printer text-primary me-1 font-size-16"></i>
            </a>
            <div ngbDropdownMenu aria-labelledby="dropdownPrint" class="dropdown-menu dropdown-menu-end">
              <button ngbDropdownItem (click)="invokeParentPrintPDFMethod('awb')">AWB Download</button>
              <button ngbDropdownItem (click)="invokeParentPrintPDFMethod('POD')">POD Download</button>
            </div>
        </div>
        <ng-container  *ngIf="action.lockUnlock">
        <a  class="" href="javascript:void(0)" (click)="invokeParentLockUnlockMethod()">
            <i *ngIf="unlock" title="Unlocked | Click to Lock" class="bx bxs-lock-open text-success me-1 font-size-16"></i>
            <i *ngIf="lock" title="Locked | Click to Unlock" class="bx bxs-lock text-danger me-1 font-size-16"></i>
       </a>
       </ng-container>
        <ng-container *ngIf="this.action.cancelIrn">
        <a  class="" href="javascript:void(0)" (click)="invokeParentCancelIRNMethod()">
            <i *ngIf="unlock" title="Cancel IRN" class="mdi mdi-close-circle-outline text-danger font-size-18"></i>
       </a>
       </ng-container>
       <ng-container *ngIf="this.action.delete">
        <a class="" href="javascript:void(0)" title="Delete" (click)="invokeParentDeleteMethod()">
              <i class="bx bx-trash text-danger me-1 font-size-16"></i>
          </a> 
        </ng-container>
    </div>
  `,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }
    `,
  ],
})

export class InvoiceDeleteActionsRenderer implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  lock = false; unlock = false; noPendingAmount = false;
  action = {
    edit: false,
    delete: false,
    print: false,
    view: false,
    lockUnlock: false,
    updateDue: false,
    cancelIrn: false
  }
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.action.edit = this.params.context?.actionConfig?.edit || this.params?.data?.edit;
    this.action.delete = this.params.context?.actionConfig?.delete;
    this.action.print = this.params.context?.actionConfig?.print;
    this.action.lockUnlock = this.params.context?.actionConfig?.lockUnlock;
    this.action.updateDue = this.params.context?.actionConfig?.updateDue;
    this.action.view = this.params.context?.actionConfig?.view;
    this.action.cancelIrn = (this.params.context.componentName === 'SalesInvoiceListComponent'
      || this.params.context.componentName === 'SupplementaryInvoiceListComponent')
      && this.params.data?.iscanceltimeexpired === false;
    if (this.params.data) {
      this.lock = this.params.data.islock ? true : false;
      this.unlock = !this.params.data.islock ? true : false;
      this.noPendingAmount = parseFloat(this.params.data.amountbalance) == 0 ? true : false;
    }
    if (this.params.context.componentName === 'SalesInvoiceListComponent') {
      this.action.edit = !this.lock;
      this.action.view = this.lock;
    }
    if(this.params.context.componentName === 'ListNewReportComponent'){
      this.params.data.customreportname == ''  || this.params.data.customreportname == null  ? this.action.delete = false : this.action.delete = true;
    }
  }
  // {delete: true, edit: true, print: true, lockUnlock: true} 
  public invokeParentEditMethod() {
    this.params.context.componentParent.editAction(this.params.node.data);
  }
  public invokeParentViewMethod() {
    this.params.context.componentParent.viewAction(this.params.node.data);
  }
  public invokeParentDeleteMethod() {
    this.params.context.componentParent.deleteAction(this.params.node.data);
  }
  public invokeParentLockUnlockMethod() {
    this.params.context.componentParent.lockUnlockAction(this.params.node.data);
  }
  public invokeParentPrintPDFMethod(options?: string) {
    this.params.context.componentParent.printPdfAction(this.params.node.data, options);
  }
  public invokeParentUpdateAmountMethod() {
    this.params.context.componentParent.UpdateAmount(this.params.node.data);
  }
  public invokeParentCancelIRNMethod() {
    this.params.context.componentParent.cancelIRN(this.params.node.data);
  }
  refresh(): boolean {
    return false;
  }
}
